import React, { useContext } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { LOADING_TYPE, RUNNING_SUBSCRIPTION_TPYE } from "src/stores/krediflow/InvoiceEnums";
import { InvoiceWorkflowUsers } from "src/screens/creditors/creditor/details/actions/assignInvoice/InvoiceWorkflowUsers";
import styles from "./InvoiceWorkflowTab.module.css";

const InvoiceWorkflowTabBase = () => {
    const { t } = useTranslation();

    const { invoiceStore, invoiceListStore } = useContext(RootStoreContext);

    return (
        <div
            className={`${styles.InvoiceWorkflowTabContainer} ${
                !invoiceListStore.isBatchProcessing ? styles.DisplayDividingBar : ""
            } d-flex ${
                invoiceStore.loadingType === LOADING_TYPE.INITIALIZING
                    ? "justify-content-center"
                    : "justify-content-start"
            }`}
        >
            {invoiceStore.loadingType === LOADING_TYPE.INITIALIZING ||
            invoiceStore.runningSubscriptionType === RUNNING_SUBSCRIPTION_TPYE.WORKFLOW_USERS ||
            (invoiceStore.currentInvoice &&
                invoiceStore.currentInvoice.isConcludingHumanTaskAssignRealestateAndOtherData) ? (
                <div className={styles.LoadingContainer}>
                    <UI.RotatingSpinner noLogo size={25} className={styles.LoadingTicketSpinner} />
                    <div className="ml-2">{t("screens.kredi_flow.loading_workflow_users")}</div>
                </div>
            ) : (
                <InvoiceWorkflowUsers type="tab" />
            )}
        </div>
    );
};

export const InvoiceWorkflowTab = Sentry.withProfiler(observer(InvoiceWorkflowTabBase));
